import { gql } from "@apollo/client"

export const EDIT_STARTERKIT = gql`
    mutation editStarterKit($_id: String, $args: EditStarterKit){
        editStarterKit(_id:$_id, args: $args){
            success
            statusCode
        }
    }
`